import React from 'react'
import { Boton } from './buttonStyle';
import './button.scss'

const ButtonHelp = ({id_boton, clases, funcion, nombre, tipo, disabled}) => {
    return (
        <Boton id={id_boton} className={clases} onClick={funcion} type={tipo}
        disabled={disabled}>{nombre}<i className="ms-2 fa-solid fa-file"></i></Boton>
    )
}

export default ButtonHelp
